<template>
    <v-container class="pa-5" fluid>
        <ConfirmDialog
            :is-open="deletePersonalPickupDialog"
            :data="personalPickup"
            removal
            @on-confirm="deletePersonalPickup"
            @on-abort="closeDeletePersonalPickupDialog"
        >
            <template #title>
                Usuwanie odbioru osobistego
            </template>
            <template #content>
                Czy na pewno chcesz usunąć odbiór osobisty?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>
        <page-title>Odbiory osobiste</page-title>
        <v-row align="center">
            <v-col cols="12" lg="4" md="6">
                <v-btn
                    color="secondary"
                    medium
                    data-sentry-label="Dodaj odbiór osobisty"
                    @click="createPersonalPickup()"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Dodaj WZ
                </v-btn>
                <v-btn
                    color="secondary"
                    medium
                    class="ml-4"
                    data-sentry-label="Dodaj odbiór osobisty"
                    @click="createPersonalPackagesPickup()"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Dodaj paczkę
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="personalPickups"
                        :loading="personalPickupsLoading"
                        :footer-props="footerProps"
                        :page.sync="pagination.page"
                        :server-items-length="pagination.itemsLength"
                        :mobile-breakpoint="0"
                        :item-class="setSelectedRow"
                        name="personalPickupsData"
                        @pagination="updatePagination"
                    >
                        <template #item.number="{item}">
                            <template v-if="item.number">
                                {{ item.number }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.customer="{item}">
                            <template v-if="item.customer">
                                {{ item.customer }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.createdBy="{item}">
                            <template v-if="item.createdBy.firstName && item.createdBy.lastName">
                                {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
                            </template>
                            <template v-else>
                                {{ item.createdBy.username }}
                            </template>
                        </template>
                        <template #item.createdAt="{item}">
                            {{ formatDate(item.createdAt) }}
                        </template>
                        <template #item.status="{item}">
                            {{ item.status.name }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            v-if="item.previewUrl"
                                            icon
                                            data-sentry-label="Generowanie wydruku"
                                            v-on="on"
                                            @click="showPersonalPickupPreview(item.previewUrl)"
                                        >
                                            <v-icon color="blue">
                                                mdi-printer
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Drukuj</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Otwórz WZ"
                                            v-on="on"
                                            @click="openPersonalPickup(item)"
                                        >
                                            <v-icon color="teal">
                                                mdi-ballot
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Otwórz</span>
                                </v-tooltip>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template v-if="item.statusId !== 20" #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Usuń"
                                            v-on="on"
                                            @click="showDeletePersonalPickupDialog(item)"
                                        >
                                            <v-icon color="pink">
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Usuń</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { apiConfig } from '@/config'
import PageTitle from '@/components/common/PageTitle'
import { errorHandler } from '@/utils/errorHandler'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import dateFormatter from '@/mixins/dateFormatter'
import customFilters from '@/mixins/customFilters'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'

export default {
    name: 'PersonalPickupsList',
    components: {
        PageTitle,
        ConfirmDialog,
    },
    mixins: [
        pagination,
        tooltipDelay,
        filters,
        dateFormatter,
        customFilters,
        dataTableClassSetter
    ],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.clearSelectedListItemId()
        }
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            personalPickupsOrdersDialog: false,
            deletePersonalPickupDialog: false,
            personalPickup: null,
            personalPickupDialog: false,
            headers: [
                {
                    text: 'Numer',
                    value: 'number',
                    sortable: false,
                },
                {
                    text: 'Odbiorca',
                    value: 'customer',
                    sortable: false,
                },
                {
                    text: 'Utworzone przez',
                    value: 'createdBy',
                    sortable: false,
                    width: 500
                },
                {
                    text: 'Data utworzenia',
                    value: 'createdAt',
                    sortable: false,
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 180
                }
            ]
        }
    },
    computed: {
        personalPickups() {
            return this.$store.state.shipments.personalPickups.personalPickups.personalPickups
        },
        personalPickupsLoading() {
            return this.$store.state.shipments.personalPickups.personalPickups.personalPickupsLoading
        },
        selectedPersonalPickupId() {
            return this.$store.state.common.selectedListItemId
        },
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.getPersonalPickups()
    },
    methods: {
        setSelectedRow(item) {
            if (item.id === this.selectedPersonalPickupId) {
                return 'isSelected'
            }
        },
        getPersonalPickups() {
            this.$store.dispatch('shipments/personalPickups/getPersonalPickups', {
                paginate: this.paginate(),
                query: ''
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        createPersonalPickup() {
            this.$router.push({
                name: 'shipmentsPersonalPickupsPersonalPickupCreate'
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        createPersonalPackagesPickup() {
            this.$router.push({
                name: 'shipmentsPersonalPickupsPersonalPackagesPickupCreate'
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        closePersonalPickupsOrdersDialog() {
            this.personalPickupsOrdersDialog = false
        },
        openPersonalPickup(personalPickup) {
            this.savePagination(this.$options.name)
            this.saveFiltersCleared()
            this.setSelectedListItemId(personalPickup.id)
            const route = personalPickup.personalPickupPackages.length > 0 
                ? 'shipmentsPersonalPickupsPersonalPackagesPickup'
                : 'shipmentsPersonalPickupsPersonalPickup'
            
            this.$router.push({
                name: route,
                params: { id: personalPickup.id }
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showDeletePersonalPickupDialog(personalPickup) {
            this.deletePersonalPickupDialog = true
            this.personalPickup = personalPickup
        },
        closeDeletePersonalPickupDialog() {
            this.deletePersonalPickupDialog = false
        },
        deletePersonalPickup(personalPickup) {
            this.personalPickupLoadingOnDelete = true
            this.$store.dispatch('shipments/personalPickups/deletePersonalPickup', personalPickup.id)
                .then(() => {
                    this.getPersonalPickups()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeDeletePersonalPickupDialog()
                    this.personalPickupLoadingOnDelete = false
                })
        },
        showPersonalPickupPreview(pdfFile) {
            const file = this.taskPreviewURI(pdfFile)

            window.open(file, '_blank')
        },
        taskPreviewURI(image) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            return `${mediaRoot}${image}`
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && !this.savedPagination.pagination) {
                this.getPersonalPickups()
            }
            this.clearPaginationPending()
        }
    },
}
</script>
